import { render, staticRenderFns } from "./YellowStrip.vue?vue&type=template&id=7e70bf12&scoped=true&"
import script from "./YellowStrip.vue?vue&type=script&lang=js&"
export * from "./YellowStrip.vue?vue&type=script&lang=js&"
import style0 from "./YellowStrip.vue?vue&type=style&index=0&id=7e70bf12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e70bf12",
  null
  
)

export default component.exports